// removed by extract-text-webpack-plugin
module.exports = {"black":"#000000","faster":".2s","link":"_2tLkOl6Mqa3TAQHIQAozZA","xs":"VgFtjYFbjQxVZGuZKHa6m","s":"_1sNUeT3iYAVmreExpL5foL","m":"_3xPwO7UZyEWR-XRtdBvOYB","l":"_2N32XunXmIrEnV71TAg4MT","xl":"_21UU3ud-tZeT5TsSZ0Vh_0"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Link/LinkHeading/LinkHeading.css
// module id = 973
// module chunks = 0